import { SimpleGrid, Stat, StatLabel, StatNumber } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { fetchStats } from '../../../utils/statsApi';

const NewHomeStats = () => {
  const statsQuery = useQuery({
    queryKey: ['stats'],
    queryFn: async () => {
      const response = await fetchStats();
      return response;
    }
  });
  const statsResult = statsQuery.data;
  const stats = useMemo(() => {
    return [
      // {
      //   title: 'Liquidity Source',
      //   value: '-'
      // },
      {
        title: 'Total Volume',
        value: statsResult ? Number(statsResult.d3xTotalVolume).toFixed(0) : '-'
      },
      {
        title: 'Total Wallets',
        value: statsResult ? statsResult.addressCount : '-'
      },
      {
        title: 'Total Trades',
        value: statsResult ? statsResult.d3xTradeCount : '-'
      }
    ];
  }, [statsResult]);
  return (
    <SimpleGrid width="100%" columns={[1, null, 3]} borderY="1px solid #505050" zIndex={2} position="relative">
      {stats.map((item, index) => (
        <Stat
          key={item.title}
          color="white"
          paddingY={{ base: '40px', md: '70px' }}
          userSelect={'none'}
          lineHeight="32px"
          borderLeft={index === 0 ? '' : { md: '1px solid #505050' }}
          borderTop={index === 0 ? '' : { base: '1px solid #505050', md: 'none' }}>
          <StatNumber textAlign="center" marginBottom="18px" fontSize={{ base: '24px', md: '48px' }} fontWeight={600}>
            {item.value}
          </StatNumber>
          <StatLabel textAlign="center" fontSize="14px" fontWeight={600} color="#777E90">
            {item.title}
          </StatLabel>
        </Stat>
      ))}
    </SimpleGrid>
  );
};

export default NewHomeStats;
